const menuRouter = [
    /**
     * 采购管理
     **/
    {
        path: '/purchase/planpurchase',
        meta: { title: '采购计划' },
        component: () => import('@/views/page/purchase/planpurchase'),
        used: true,
    },
    {
        path: '/purchase/purchasecontract',
        meta: { title: '合同签订' },
        component: () => import('@/views/page/purchase/purchasecontract'),
        used: true,
    },
    {
        path: '/purchase/supplyorder',
        meta: { title: '供货订单' },
        component: () => import('@/views/page/purchase/supplyorder'),
        used: true,
    },
    {
        path: '/purchase/supplyinspect',
        meta: { title: '到货验收' },
        component: () => import('@/views/page/purchase/supplyinspect'),
        used: true,
    },
    {
        path: '/purchase/supplyreturn',
        meta: { title: '采购退货' },
        component: () => import('@/views/page/purchase/supplyreturn'),
        used: true,
    },
    {
        path: '/purchase/supplyinto',
        meta: { title: '采购入库' },
        component: () => import('@/views/page/purchase/supplyinto'),
        used: true,
    },
    {
        path: '/purchase/supplyintoret',
        meta: { title: '采购入库退出' },
        component: () => import('@/views/page/purchase/supplyintoret'),
        used: true,
    },
    {
        path: '/purchase/purchaseinvoice',
        meta: { title: '合同发票' },
        component: () => import('@/views/page/purchase/purchaseinvoice'),
        used: true,
    },
    {
        path: '/purchase/purchasepay',
        meta: { title: '合同支付' },
        component: () => import('@/views/page/purchase/purchasepay'),
        used: true,
    },
    {
        path: '/purchase/purchasesettle',
        meta: { title: '合同结算' },
        component: () => import('@/views/page/purchase/purchasesettle'),
        used: true,
    },
    {
        path: '/purchase/reimburse',
        meta: { title: '报销单' },
        component: () => import('@/views/page/purchase/reimburse'),
        used: true,
    },
    {
        path: '/purchase/sporadicpurchase',
        meta: { title: '零星采购申请' },
        component: () => import('@/views/page/purchase/sporadicpurchase'),
        used: true,
    },
    {
        path: '/purchase/purchasepriceanal',
        meta: { title: '采购价格分析' },
        component: () => import('@/views/page/purchase/purchasepriceanal'),
        used: true,
    },
    {
        path: '/purchase/purchaseanal',
        meta: { title: '采购分析' },
        component: () => import('@/views/page/purchase/purchaseanal'),
        used: true,
    },
    {
        path: '/purchase/purchasedetailed',
        meta: { title: '采购明细表'},
        component: () => import('@/views/page/purchase/purchasedetailed'),
        used: true,
    },
    {
        path: '/purchase/supplyorderdetailed',
        meta: { title: '采购订单明细表'},
        component: () => import('@/views/page/purchase/supplyorderdetailed'),
        used: true,
    }
]

export default menuRouter
